import React from 'react';
import classNames from 'classnames';

import s from './styles.module.scss';

const SegmentedLabel: React.FC<{
  text: string;
  indicatorColor: 'red' | 'green' | 'yellow' | '';
  className?: string;
}> = ({ text, indicatorColor, className }) => (
  <div className={classNames(s['segmented-label-wrapper'], className)}>
    {text}
    {indicatorColor && (
      <span className={`${s['indicator-dot']} ${s[indicatorColor]}`} />
    )}
  </div>
);

export default SegmentedLabel;
